import React, { useState, useEffect } from 'react';
import HeaderTitleBar from './HeaderTitleBar';
import { SaveContainerDTO, SaveContainerDropDTO } from 'business/models/Models';
import RMTable from 'components/customComponents/Controls/RMTable';
import RMCheckBox from 'components/customComponents/Controls/tableSelectionCheckBox';
import { createNewDrop } from './utils';
import { IStyle } from 'Styles';

interface PlateDropsProps {
  selectedIndices: number[];
  currentPlateTypes: SaveContainerDTO[];
  setCurrentPlateTypes: React.Dispatch<React.SetStateAction<SaveContainerDTO[]>>;
  deletedDropIds: number[];
  setDeletedDropIds: React.Dispatch<React.SetStateAction<number[]>>;
  setIsDirty: React.Dispatch<React.SetStateAction<boolean>>;
  dummyDropIds: number[];
  setDummyDropIds: React.Dispatch<React.SetStateAction<number[]>>;
  editId: number;
  isNumDropsBlurToggle: boolean;
}
const PlateDrops = (props: PlateDropsProps) => {
  const {
    selectedIndices,
    currentPlateTypes,
    setCurrentPlateTypes,
    deletedDropIds,
    setDeletedDropIds,
    setIsDirty,
    dummyDropIds,
    setDummyDropIds,
    editId,
    isNumDropsBlurToggle,
  } = props;
  const [selectedDropIndex, setSelectedDropIndex] = useState([]);
  const [renderedDropsData, setRenderedDropsData] = useState([]);

  const columns = [
    {
      id: 'dropNumber',
      Header: 'Drop',
      accessor: 'dropNumber',
      className: 'image-settings-name',
      editOptions: { inputType: 'text' },
    },
    {
      id: 'enabled',
      Header: 'Enabled',
      accessor: 'enabled',
      className: 'image-settings-name',
      editOptions: { inputType: 'text' },
    },
  ];

  useEffect(() => {
    const selectedPlateType = currentPlateTypes[selectedIndices[0]];
    const dropsData = selectedPlateType.containerDrops;

    const dropNum = parseInt(
      currentPlateTypes[selectedIndices[0]].maxNumDrops.toString(),
    );
    const dropEntriesNum = dropsData.length;
    const newDropsNum = dropNum - dropEntriesNum;
    if (selectedPlateType.maxNumDrops === 0) {
      setDummyDropIds([]);
      setRenderedDropsData([]);
    } else if (newDropsNum === 0) {
      setRenderedDropsData([...dropsData]);
      setDummyDropIds([]);
    } else if (newDropsNum > 0) {
      const nullArray = new Array(dropNum).fill(null);
      const dropArray = new Array(dropNum).fill(null);
      const containerId = currentPlateTypes[selectedIndices[0]].id;
      const newDummyIds = [];
      nullArray.forEach((val, index) => {
        const dropIndex = dropsData.findIndex((drop) => drop.dropNumber === index + 1);
        if (dropIndex === -1) {
          const newDrop = createNewDrop(index + 1, containerId);
          newDummyIds.push(newDrop.id);
          dropArray[index] = newDrop;
        } else {
          dropArray[index] = dropsData[dropIndex];
        }
      });
      setDummyDropIds([...newDummyIds]);
      setRenderedDropsData(dropArray);
    }
  }, [selectedIndices, editId, isNumDropsBlurToggle]);

  const onChangeDropNum = (e, drop) => {
    if (dummyDropIds.includes(drop.id)) {
      setCurrentPlateTypes((prev) => {
        const updatedPrev = [...prev];
        const updatedPlateType = new SaveContainerDTO(prev[selectedIndices[0]]);
        updatedPlateType.containerDrops = [...updatedPlateType.containerDrops];
        const indexNewDrop = renderedDropsData.findIndex((d) => d.id === drop.id);
        const newDrop = new SaveContainerDropDTO(renderedDropsData[indexNewDrop]);
        updatedPlateType.containerDrops.push(newDrop);
        updatedPrev[selectedIndices[0]] = updatedPlateType;
        return updatedPrev;
      });
      setDummyDropIds(dummyDropIds.filter((id) => id !== drop.id));
    } else if (!deletedDropIds.includes(drop.id)) {
      setDeletedDropIds([...deletedDropIds, drop.id]);
    } else {
      setDeletedDropIds(
        deletedDropIds.filter((dropId) => {
          return dropId !== drop.id;
        }),
      );
    }
    setIsDirty(true);
  };
  const dtoToTableRow = (drop: SaveContainerDropDTO) => {
    return {
      dropNumber: drop.dropNumber,
      enabled: (
        <RMCheckBox
          id="platedrops-totablerow-checkbox"
          onChange={(e) => {
            onChangeDropNum(e, drop);
          }}
          checked={!deletedDropIds.includes(drop.id) && !dummyDropIds.includes(drop.id)}
          disabled={
            selectedIndices.length > 0
              ? currentPlateTypes[selectedIndices[0]].inUse
              : false
          }
        />
      ),
    };
  };
  const tableRows = () => {
    return renderedDropsData.map((drop: SaveContainerDropDTO) => {
      return dtoToTableRow(drop);
    });
  };

  const handleOnRowCLick = (row) => {
    setSelectedDropIndex([row.index]);
  };
  return (
    <>
      {currentPlateTypes[selectedIndices[0]].maxNumDrops > 0 && (
        <div id="platedrops-container" className="min-w-[120px]">
          <HeaderTitleBar title="Plate Drops" />
          <RMTable
            columns={columns}
            data={tableRows()}
            tableClass={'w-100'}
            onRowClicked={handleOnRowCLick}
            selectedIds={selectedDropIndex}
            mainContainerStyle={styles.plateDefinitionTable}
          />
        </div>
      )}
    </>
  );
};
const styles: IStyle = {
  plateDefinitionTable: {
    height: '72vh',
    overflow: 'scroll',
  },
};
export default PlateDrops;
